import { useEffect, useRef, useState } from 'react'
import Swal from 'sweetalert2'
import { getAllTenants } from '../../../Services/tenantService'

const useTenantsPagination = (history, activo = true) => {
    const token = JSON.parse(atob(sessionStorage.getItem('token').split('.')[1]))
    const rol = token.authorities[0]

    const [tenants, setTenants] = useState([])
    const [isLoad, setIsLoad] = useState(true)
    const [page, setPage] = useState(0)
    const [totalRegister, setTotalRegister] = useState(0)
    const [totalPage, setTotalPage] = useState(0)
    const [query, setQuery] = useState('')
    const lastSearchRef = useRef('')

    const fetchTenants = (pageNum, searchTerm) => {
        const trimmed = searchTerm.trim()
        return getAllTenants(activo, pageNum, trimmed, 50)
    }

    useEffect(() => {
        if (rol !== 'ROLE_ADMIN_MAGENTA') {
            history.goBack()
            return
        }
        if (isLoad) {
            fetchTenants(0, query)
                .then((res) => {
                    setTenants(res.data.content || [])
                    setTotalRegister(res.data.totalElements ?? 0)
                    setTotalPage(res.data.totalPages ?? 0)
                    setIsLoad(false)
                })
                .catch(() => {
                    Swal.fire({
                        text: 'No se pudo cargar la lista de tenants.',
                        icon: 'error',
                        confirmButtonText: 'Aceptar',
                    })
                    setIsLoad(false)
                })
        } else {
            setIsLoad(false)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isLoad])

    const nextPage = () => {
        if (totalPage === 0 || page === totalPage - 1) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                icon: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }

        fetchTenants(page + 1, query)
            .then((res) => {
                setPage(page + 1)
                setTenants(res.data.content || [])
                setTotalRegister(res.data.totalElements ?? 0)
                setTotalPage(res.data.totalPages ?? 0)
                setIsLoad(false)
            })
            .catch(() => console.log('error'))
    }

    const previousPage = () => {
        if (page === 0) {
            Swal.fire({
                toast: true,
                position: 'top',
                title: 'No hay mas páginas',
                icon: 'info',
                showConfirmButton: false,
                timer: 1000,
            })
            return
        }

        fetchTenants(page - 1, query)
            .then((res) => {
                setPage(page - 1)
                setTenants(res.data.content || [])
                setTotalRegister(res.data.totalElements ?? 0)
                setTotalPage(res.data.totalPages ?? 0)
                setIsLoad(false)
            })
            .catch(() => console.log('error'))
    }

    const handleBuscador = (e) => {
        setQuery(e.target.value)
        if (e.key === 'Enter') {
            const trimmedValue = e.target.value.trim()

            if (trimmedValue === '' && lastSearchRef.current !== '') {
                fetchTenants(0, '')
                    .then((res) => {
                        setPage(0)
                        setTenants(res.data.content || [])
                        setTotalRegister(res.data.totalElements ?? 0)
                        setTotalPage(res.data.totalPages ?? 0)
                        setIsLoad(false)
                        lastSearchRef.current = ''
                    })
                    .catch(() => console.log('error'))
            } else if (
                trimmedValue !== '' &&
                trimmedValue !== lastSearchRef.current
            ) {
                fetchTenants(0, trimmedValue)
                    .then((res) => {
                        setPage(0)
                        setTenants(res.data.content || [])
                        setTotalRegister(res.data.totalElements ?? 0)
                        setTotalPage(res.data.totalPages ?? 0)
                        setIsLoad(false)
                        lastSearchRef.current = trimmedValue
                    })
                    .catch(() => console.log('error'))
            }
        }
    }

    return {
        tenants,
        setIsLoad,
        page,
        totalRegister,
        totalPage,
        handleBuscador,
        nextPage,
        previousPage,
        setQuery,
    }
}

export default useTenantsPagination
